import PropTypes from 'prop-types';
import React from 'react';

import './CardTitle.scss';

export default class CardTitle extends React.PureComponent {
    static propTypes = {
        /**
         * string to be rendered as CardTitle
         */
        title: PropTypes.string.isRequired,
        /**
         * enum of header html tags
         */
        headerTag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
        /**
         * custom class name
         */
        className: PropTypes.string,
    };

    static defaultProps = {
        title: '',
        headerTag: 'h2',
        className: '',
    };

    render() {
        const { title, children, className } = this.props;
        const HeaderTag = this.props.headerTag; // Dynamic JSX tags require capitalization
        const content = title ? title : children;
        return (
            <HeaderTag className={`component-Elements-CardTitle ${className}`}>
                {content}
            </HeaderTag>
        );
    }
}
